/**
/**
 * ReportSubscribersSeed entity class
 */

import moment from 'moment'

/**
 * ReportSubscribersSeedFactory
 * returns ReportSubscribersSeed entity class
 *
 * @class ReportSubscribersSeedFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSubscribersSeed} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSubscribersSeedFactory
 */
/* @ngInject */
export default function ReportSubscribersSeedFactory (Entity, ReportSeed) {
  /* === ReportSubscribersSeed class === */

  /**
   * ReportSubscribersSeed model
   *
   * @class ReportSubscribersSeed
   * @classdesc ReportSubscribersSeed model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportSubscribersSeed entity fields
   * @return {models.ReportSubscribersSeed} ReportSubscribersSeed entity
   */
  function ReportSubscribersSeed () {
    var obj = ReportSeed.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSubscribersSeed.prototype = Object.create(ReportSeed.prototype)
  ReportSubscribersSeed.prototype.constructor = ReportSubscribersSeed

  /* === ReportSubscribersSeed instance methods & fields === */

  Object.assign(ReportSubscribersSeed.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportSubscribersSeed#
     * @type {Object}
     */
    _fields: {
      name: String,
      reportType: String,
      networks: [],
      from: Number,
      to: Number,
      days: Number,
      $fromDateTime: Date,
      $toDateTime: Date
    },

    /**
     * instance fields by types
     *
     * @memberof models.ReportSubscribersSeed#
     * @type {Object}
     */
    _fieldsByTypes: { // SUBSCRIBERS_REPORT_REPORTING_METHOD

      ACTIVE_SUBSCRIBERS: [
        'name',
        'networks',
        'from',
        'to'
      ],
      TOTAL_SUBSCRIBERS: [
        'name',
        'networks'
      ],
      EXPIRING_SUBSCRIBERS: [
        'name',
        'networks',
        'from',
        'to'
      ],
      ACTIVATIONS_OF_SUBSCRIBERS: [
        'name',
        'networks',
        'from',
        'to'
      ],
      PRE_ACTIVE: [
        'name',
        'networks',
        'from',
        'to'
      ]
    },

    /**
     * Get underlying object
     *
     * @memberof models.ReportSubscribersSeed#
     * @return {Object} new underlying object as plain object
     * @override
     */
    _object: function () {
      this.from = moment(this.$fromDateTime).utc().unix()
      this.to = moment(this.$toDateTime).endOf('day').utc().unix()

      var ret = Entity.prototype._object.apply(this, arguments)

      // leave only necessary fields for that type of extension node
      var fields = this._fieldsByTypes[ret.reportType]
      for (var f in ret) {
        if (hasOwnProperty.call(ret, f) && fields.indexOf(f) === -1) {
          delete ret[f]
        }
      }

      return ret
    },

    /**
     * Prepare object
     *
     * @memberof models.StreamsReportSeed#
     * @override
     */
    _prepare: function () {
      this.$fromDateTime = moment().subtract(1, 'day').toDate()
      this.$toDateTime = moment().subtract(1, 'day').toDate()
    }
  })

  /* === ReportSubscribersSeed static methods & fields === */

  // copy all static methods from ReportSeed class
  Object.assign(ReportSubscribersSeed, ReportSeed)
  ReportSubscribersSeed._name = 'ReportSubscribersSeed'
  ReportSubscribersSeed.init()

  // permissions
  // ReportSubscribersSeed.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportSubscribersSeed
}
